import { Component, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Advertiser, ConsumerInformationStrategy, ProductReward, StaffInformationStrategy } from 'src/app/api/api-campaigns.service.generated';
import { formToRewardData, RewardDataEditComponent } from '../../_/reward-data-edit/reward-data-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-information-strategy',
  templateUrl: './information-strategy.component.html',
  styleUrls: ['./information-strategy.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatSlideToggleModule,
    RewardDataEditComponent
  ]
})
export class InformationStrategyComponent implements OnChanges {

  @Input() strategy: ConsumerInformationStrategy | StaffInformationStrategy;
  @Input() advertiserId: string;

  @Input() advertiser: Advertiser;
  @Input() rewardProducts: ProductReward[];

  form = new FormGroup({
    // information strategy
    joinReward: new FormControl(),
    validateReward: new FormControl(false)   // for staff only
  });

  @Input() isConsumerCampaign: boolean;

  constructor() { }

  ngOnChanges(): void {
    if (!this.strategy) return;

    this.setFormValue(this.strategy);
  }


  setFormValue(model: ConsumerInformationStrategy | StaffInformationStrategy) {
    if (model.name === 'ConsumerInformationStrategy')
      this.form.patchValue({
        joinReward: (model as ConsumerInformationStrategy).joinReward
      });

    if (model.name === 'StaffInformationStrategy')
      this.form.patchValue({
        validateReward: (model as StaffInformationStrategy).validateReward
      });
  }

  getFormValue(): ConsumerInformationStrategy | StaffInformationStrategy {
    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
      return null;
    }
    const f = this.form.value;

    if (this.isConsumerCampaign)
      return new ConsumerInformationStrategy({
        ...this.strategy as ConsumerInformationStrategy,
        name: 'ConsumerInformationStrategy',
        joinReward: formToRewardData(f.joinReward)
      });

    return new StaffInformationStrategy({
      ...this.strategy as StaffInformationStrategy,
      validateReward: f.validateReward,
      name: 'StaffInformationStrategy'
    });
  }

  forceValidatorsToDisplayErrors() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).markAsTouched();
      this.form.get(key).markAsDirty();
    });
  }

  async onSubmit() {
  }



}
